import { useState, useEffect, FC, PropsWithChildren } from "react";
import { useAuthStatus } from "../../lib/stores/auth-store";

const AuthProvider: FC<PropsWithChildren> = ({ children }) => {
  const [loading, setLoading] = useState<boolean>(true);
  const setIsLoggedIn = useAuthStatus((state) => state.setIsLoggedIn);

  useEffect(() => {
    function clearTokens() {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("lt");
      setIsLoggedIn(false);
      setLoading(false);
    }

    // La session repose uniquement sur le token Sanctum ("lt").
    // Tout utilisateur qui arrive sans "lt" est immédiatement déconnecté.
    const laravelToken = localStorage.getItem("lt");
    if (laravelToken) {
      setIsLoggedIn(true);
      setLoading(false);
    } else {
      clearTokens();
    }
  }, [setIsLoggedIn]);

  return <> {!loading && children} </>;
};

export default AuthProvider;
